var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"bbox-link",class:[_vm.colors, { disabled: _vm.disabled, block: _vm.block }],attrs:{"href":_vm.href,"target":_vm.openNewTab ? '_blank' : '_self',"tabindex":"0"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }